import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_MULTI_ACCOUNT_PANEL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_MULTI_ACCOUNT_PANEL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/MultiAccountPanel')
};